export default __webpack_public_path__ + "static/media/embed.9587f192.svg";